
import React from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface PublicToggleProps {
  isPublic: boolean;
  onChange: (checked: boolean) => void;
}

const PublicToggle: React.FC<PublicToggleProps> = ({ isPublic, onChange }) => {
  return (
    <div className="flex items-center space-x-2 pt-2">
      <Switch
        id="isPublic"
        checked={isPublic}
        onCheckedChange={onChange}
      />
      <Label htmlFor="isPublic" className="cursor-pointer">
        Make this agent public and available for purchase
      </Label>
    </div>
  );
};

export default PublicToggle;
